import { z } from "zod";
import type { infer as zInfer } from "zod/lib/types";
import {
  automationComponent,
  baseAutomation,
  userDrivenAttributes,
} from "hooks/firestore/v2/models/baseAutomation";

const automationRequirement = automationComponent.extend({
  type: z.enum(["SEM_BET_STAKE", "NON_SEM_BET_STAKE"]),
  userDrivenAttributes,
});

export const tokenAutomation = baseAutomation.extend({
  requirements: z.array(automationComponent).nullish(),
  attributes: z
    .object({
      eventBasedTokens: z.boolean(),
      tokenInfoPrefix: z.string().optional(),
      tokenBetSlipPriority: z.number().optional(),
    })
    .optional(),
});

const isStakeRequirementSchema = automationRequirement.pick({ type: true });

export const isTokenRequirementWithUserAttributes = (
  obj: unknown,
): obj is AutomationRequirement => {
  const result = isStakeRequirementSchema.safeParse(obj);
  return (
    result.success &&
    (result.data.type === "SEM_BET_STAKE" ||
      result.data.type === "NON_SEM_BET_STAKE")
  );
};

export type TokenAutomation = zInfer<typeof tokenAutomation>;
export type AutomationRequirement = zInfer<typeof automationRequirement>;
